


















































import { contactItems, ContactModel } from '@web/models/ContactModels';
import { Component } from 'vue-property-decorator';
import HomeSection from '../Home/Section.abstract';

@Component
export default class IconsContent extends HomeSection {
  public readonly contactItems: ContactModel[] = contactItems;

  imagesRefs = {
    phone: 'phone',
    address: 'address',
    email: 'email',
  };

  imagesAppeareence = true;
}
